// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"406":"73aea900","953":"56d97608"}[chunkId] + ".js";
};